export class PpcOrdoclicInformationsForm {
  nomMutuelle: string;
  numeroMutuelle: string;
  ald: boolean;
  iah: number;
  typeAppareil: string;
  pression: string;
  typeInterface: string;
  marqueModele: string;
  ameliorationSymptomatologie: boolean;
  patientObservant: boolean;
  commentaire?: string;

  constructor(
    nomMutuelle: string,
    numeroMutuelle: string,
    ald: boolean,
    iah: number,
    typeAppareil: string,
    pression: string,
    typeInterface: string,
    marqueModele: string,
    ameliorationSymptomatologie: boolean,
    patientObservant: boolean,
    commentaire?: string,
  ) {
    this.nomMutuelle = nomMutuelle;
    this.numeroMutuelle = numeroMutuelle;
    this.ald = ald;
    this.iah = iah;
    this.typeAppareil = typeAppareil;
    this.pression = pression;
    this.typeInterface = typeInterface;
    this.marqueModele = marqueModele;
    this.ameliorationSymptomatologie = ameliorationSymptomatologie;
    this.patientObservant = patientObservant;
    this.commentaire = commentaire;
  }
}
